import { duplicateWithIndex } from "../../../helpers/duplicateWithIndex";

export default [
    {
        key: "dopolnitelnaya_polka",
        allArray: "allPolkaStellazh",
        activeArray: "activePolkaStellazh",
        position: "top",
        extra: (el) => {
            const defaultCount = 4;
            if (el.name.includes("__1000x")) duplicateWithIndex(el, defaultCount + 3, servObj.allPolkaStellazh);
            if (el.name.includes("__1500x")) duplicateWithIndex(el, defaultCount + 5, servObj.allPolkaStellazh);
            if (el.name.includes("__1800x")) duplicateWithIndex(el, defaultCount + 6, servObj.allPolkaStellazh);
            if (el.name.includes("__1850x")) duplicateWithIndex(el, defaultCount + 6, servObj.allPolkaStellazh);
            if (el.name.includes("__1950x")) duplicateWithIndex(el, defaultCount + 6, servObj.allPolkaStellazh);
            if (el.name.includes("__2000x")) duplicateWithIndex(el, defaultCount + 6, servObj.allPolkaStellazh);
        },
    },
];
